import * as React from 'react';
import { forwardRef, useCallback, useState } from 'react';
import { Icon } from '@components/atoms/icon';
import type { PasswordTextFieldProps } from '@components/moleculs/password-text-field/types';
import { TextField } from '@components/moleculs/text-field';
import { styled } from 'styled-components';

import { PasswordIconClose, PasswordIconOpen } from '../../icons';

export const Molecule = forwardRef<HTMLDivElement, PasswordTextFieldProps>(
    (props, ref) => {
        const [isShowPassword, setIsShowPassword] = useState(false);
        const toggleShowPassword = useCallback(() => {
            setIsShowPassword(!isShowPassword);
        }, [isShowPassword]);

        return (
            <TextField
                type={isShowPassword ? 'text' : 'password'}
                ref={ref}
                {...props}
                InputProps={{
                    ...props.InputProps,
                    endAdornment: (
                        <Icon
                            onClick={toggleShowPassword}
                            icon={isShowPassword ? <PasswordIconOpen /> : <PasswordIconClose />}
                            $clickable={true}
                        />
                    ),
                }}
            />
        );
    },
);

export const PasswordTextField = styled(Molecule)({});
